export const INVITE_NOTIFICATIONS_UPDATED_EVENT = 'invite-notifications-updated';
export const INVITE_NOTIFICATIONS_REFRESH_INTERVAL_MS = 30_000;
export const INVITE_MENU_CONTENT_LOADED_EVENT = 'invite-menu-content-loaded';

export type InviteMenuName = 'games' | 'projects';

export const scheduleInviteMenuContentLoaded = (menu: InviteMenuName): void => {
  window.setTimeout(() => {
    window.dispatchEvent(
      new CustomEvent(INVITE_MENU_CONTENT_LOADED_EVENT, {
        detail: { menu },
      })
    );
  }, 0);
};
